import { useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { ApiFehler, schicke } from '../lib/api'
import { SitzungsAktion } from '../session/SitzungsAktion'
import { Button, TextField } from '../ui'

/** Erster Schritt nach einem Google-Login ohne bisherige Mitgliedschaft. */
export function Einrichtung({ userName }: { userName: string }) {
  const qc = useQueryClient()
  const [name, setName] = useState('')
  const [fehler, setFehler] = useState<string | null>(null)
  const [laeuft, setLaeuft] = useState(false)

  const anlegen = async (): Promise<void> => {
    setFehler(null)
    setLaeuft(true)
    try {
      await schicke('POST', '/api/households', { name })
      await qc.invalidateQueries({ queryKey: ['me'] })
    } catch (e) {
      setFehler(e instanceof ApiFehler ? e.message : 'Der Haushalt konnte nicht angelegt werden.')
    } finally {
      setLaeuft(false)
    }
  }

  return (
    <main className="inhalt einstieg">
      <div className="stack-3">
        <h1>Willkommen, {userName}</h1>
        <p className="unterzeile">
          Richte deinen ersten Haushalt ein. Du wirst automatisch als verwaltende Person
          eingetragen.
        </p>
      </div>
      <form
        className="stack-4"
        onSubmit={(e) => {
          e.preventDefault()
          void anlegen()
        }}
      >
        <TextField
          id="haushalt-name"
          label="Name des Haushalts"
          wert={name}
          onWert={setName}
          hilfe="Zum Beispiel Familie Müller"
          autoFocus
          required
        />
        {fehler ? (
          <p className="fehler" role="alert">
            {fehler}
          </p>
        ) : null}
        <div className="reihe">
          <Button type="submit" laeuft={laeuft} disabled={!name.trim()}>
            {laeuft ? 'Wird angelegt …' : 'Haushalt anlegen'}
          </Button>
        </div>
      </form>
      <SitzungsAktion />
    </main>
  )
}
